import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { environment } from '../environments/environment';

//firebase
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';

// material
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { MatFormFieldModule } from '@angular/material/form-field';

// forms
import { ReactiveFormsModule } from '@angular/forms';
import { NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';

//auth service
import { AuthService } from "./auth/auth.service";

// error handling (Sentry)
import * as Sentry from "@sentry/angular-ivy";
import { Router } from "@angular/router";

// componenets
import { SignInComponent } from './auth/sign-in/sign-in.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthorsComponent } from './author-group/authors/authors.component';
import { SelectedAuthorComponent } from './author-group/selected-author/selected-author.component';
import { NewAuthorComponent } from './author-group/new-author/new-author.component';
import { BooksComponent } from './book-group/books/books.component';
import { NewBookComponent } from './book-group/new-book/new-book.component';
import { SelectedBookComponent } from './book-group/selected-book/selected-book.component';
import { BookTestimonialsComponent } from './book-group/book-testimonials/book-testimonials.component';
import { BlogPostsComponent } from './blog-group/blog-posts/blog-posts.component';
import { SelectedBlogPostComponent } from './blog-group/selected-blog-post/selected-blog-post.component';
import { NewBlogPostComponent } from './blog-group/new-blog-post/new-blog-post.component';
import { EventsComponent } from './event-group/events/events.component';
import { SelectedEventComponent } from './event-group/selected-event/selected-event.component';
import { NewEventComponent } from './event-group/new-event/new-event.component';
import { StatsComponent } from './stats-group/stats/stats.component';

@NgModule({
  declarations: [
    AppComponent,
    SignInComponent,
    DashboardComponent,
    AuthorsComponent,
    SelectedAuthorComponent,
    NewAuthorComponent,
    BooksComponent,
    NewBookComponent,
    SelectedBookComponent,
    BookTestimonialsComponent,
    BlogPostsComponent,
    SelectedBlogPostComponent,
    NewBlogPostComponent,
    EventsComponent,
    SelectedEventComponent,
    NewEventComponent,
    StatsComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    //AngularFirestoreModule.enablePersistence(),
    AngularFireAuthModule,
    AngularFirestoreModule,
    AngularFireStorageModule,
    BrowserAnimationsModule,
    //FormsModule,
    ReactiveFormsModule,
    //MatFormFieldModule,
    MatProgressSpinnerModule,
    MatTabsModule,
    NgbTypeaheadModule,
  ],
  providers: [
    AuthService,
    // SENTRY --
    {provide: ErrorHandler, useValue: Sentry.createErrorHandler({ showDialog: false, }),},
    {provide: Sentry.TraceService,deps: [Router],},
    // -- SENTRY
  ],
  bootstrap: [AppComponent]
})
export class AppModule { 
  // SENTRY --
  constructor(trace: Sentry.TraceService) {}
  // -- SENTRY
}
